import { AccountService } from '@services/account.service';

export function appInitializer(accountService: AccountService) {
    return () => new Promise(resolve => {
        // Verifica que token aun sea válido.
        accountService.validateToken()
            .subscribe()
            .add(resolve);
    });
}